import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c1675dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Terceros", -1))
const _hoisted_3 = { class: "card-global" }
const _hoisted_4 = { class: "form-global flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label padding-label" }, "Nombre del tercero", -1))
const _hoisted_6 = { class: "flex-centered-button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Lista de terceros")
], -1))
const _hoisted_8 = { class: "card-container" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "buttons" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "popup-card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Editar tercero", -1))
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "form-global flex-column" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "label padding-label" }, "Nombre del tercero", -1))
const _hoisted_18 = { class: "flex-centered-button" }

import { ref } from 'vue';
    import { useThirdPartiesStore } from '@/stores/thirdParties';
    import { IThirdParty } from '@/interfaces/IThirdParties';
    import swal from 'sweetalert';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdpartiesView',
  setup(__props) {

    const thirdPartiesStore = useThirdPartiesStore();

    const thirdPartyForm = ref({
        name: '',
    })

    const submitFrom = async () => {
        const item : IThirdParty = {
            Cl_codigo: 0,
            Cl_nombre: thirdPartyForm.value.name,
        }
        if (await thirdPartiesStore.createData(item)) {
            thirdPartiesStore.fetchDataList()
            swal("¡Genial!", "Se ha registrado exitosamente", "success")
            thirdPartyForm.value.name = ''
        } else {
            console.log("Error, no se pudo actualizar el tercero")
            swal("Error", "No se pudo actualizar el tercero", "error")
        }
    }

    const submitEditFrom = async () => {
        const item : IThirdParty = {
            Cl_codigo: 0,
            Cl_nombre: editForm.value.name,
        }
        if (await thirdPartiesStore.updateData(item)) {
            swal("¡Genial!", "Se ha actualizado exitosamente", "success")
            clientModal.value = false
            editForm.value.name = ''
        } else {
            console.log("Error, no se pudo actualizar el tercero")
            swal("Error", "No se pudo actualizar el tercero", "error")
        }
    }

    const editItem = async( item: IThirdParty ) => {
        console.log(item)
        if ( await thirdPartiesStore.fetchSingleData(item.Cl_codigo)) {
            // Open modal with the data
            openClientModal(item)
            // Actualizar la tabla
        } else {
            console.log("Error, no se pudo obtener el tercero")
        }
    }

    const deleteItem = async ( item: IThirdParty ) => {
        console.log(item)
        if (await thirdPartiesStore.deleteData(item)) {
            // Actualizar la tabla
            console.log("Item eliminado")
            swal("¡Genial!", "Se ha eliminado exitosamente", "success")
            thirdPartiesStore.fetchDataList()
        } else {
            console.log("Error, no se pudo borrar el item")
            swal("Error", "No se pudo borrar el item", "error")
        }
    }

    // EDITAR

    const editForm = ref({
        name: '',
    })

    const clientModal = ref(false)
    const openClientModal = (tercero: IThirdParty) => {
        clientModal.value = !clientModal.value
        editForm.value.name = tercero.Cl_nombre
    }

    const closeModal = (event : Event ) => {
        if (event.target !== event.currentTarget) return;
        clientModal.value = false;
    }



return (_ctx: any,_cache: any) => {
  const _component_IconifyIcon = _resolveComponent("IconifyIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thirdPartyForm.value.name) = $event)),
              required: "",
              class: "input",
              type: "text",
              placeholder: "Nombre del producto"
            }, null, 512), [
              [_vModelText, thirdPartyForm.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _withModifiers(submitFrom, ["prevent"]),
              class: "button-global"
            }, "Registrar")
          ])
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(thirdPartiesStore).dataList, (thirdParty) => {
          return (_openBlock(), _createElementBlock("div", {
            key: thirdParty.Cl_codigo,
            class: "card-global card-size"
          }, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(thirdParty.Cl_nombre), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: ($event: any) => (editItem(thirdParty))
              }, [
                _createVNode(_component_IconifyIcon, {
                  icon: "mdi:pencil",
                  width: "20px"
                })
              ], 8, _hoisted_11),
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: ($event: any) => (deleteItem(thirdParty))
              }, [
                _createVNode(_component_IconifyIcon, {
                  icon: "mdi:delete",
                  width: "20px"
                })
              ], 8, _hoisted_12)
            ])
          ]))
        }), 128))
      ])
    ]),
    (clientModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          onClick: closeModal
        }, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("form", _hoisted_16, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.name) = $event)),
                    required: "",
                    class: "input",
                    type: "text",
                    placeholder: "Nombre del producto"
                  }, null, 512), [
                    [_vModelText, editForm.value.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(submitEditFrom, ["prevent"]),
                    class: "button-global"
                  }, "Registrar")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})